import {FAILURE_POSTFIX, SERVER_API_PREFIX, SUCCESS_POSTFIX} from 'new-constants/api.constants';

export const apiErrorReplacerMiddleware = store => next => action => {
	if (action.type.includes(SERVER_API_PREFIX) && action.error) {
		return next({
			...action,
			type: action.type.replace(SUCCESS_POSTFIX, FAILURE_POSTFIX),
		});
	} else {
		return next(action);
	}
};
